module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2000.33c0b94d.svg";